import * as React from 'react'

import { Badge, Text } from '@enechain/ecloud-designsystem'
import {
  StatusLabel,
  StatusLabel_Status,
} from '@enechain/eposition-proto/bfftypes/v1/label_pb'

type Props = {
  value: StatusLabel | undefined
}

const statusBadge: React.FC<Props> = ({ value }) => {
  if (value === undefined) {
    return null
  }

  switch (value.status) {
    case StatusLabel_Status.POSITIVE:
      return (
        <Badge status="positive" width="fit-content">
          <Text textStyle="textMd" whiteSpace="nowrap">
            {value.label}
          </Text>
        </Badge>
      )
    case StatusLabel_Status.WARNING:
      return (
        <Badge status="warning" width="fit-content">
          <Text textStyle="textMd" whiteSpace="nowrap">
            {value.label}
          </Text>
        </Badge>
      )
    case StatusLabel_Status.NEGATIVE:
      return (
        <Badge status="negative" width="fit-content">
          <Text textStyle="textMd" whiteSpace="nowrap">
            {value.label}
          </Text>
        </Badge>
      )
    case StatusLabel_Status.INFO:
      return (
        <Badge status="info" width="fit-content">
          <Text textStyle="textMd" whiteSpace="nowrap">
            {value.label}
          </Text>
        </Badge>
      )
    case StatusLabel_Status.NEUTRAL:
      return (
        <Badge status="neutral" width="fit-content">
          <Text textStyle="textMd" whiteSpace="nowrap">
            {value.label}
          </Text>
        </Badge>
      )
    default:
      return null
  }
}

export const StatusBadge = React.memo(statusBadge)
